import { createAction } from '@reduxjs/toolkit';

export const setLoading = createAction('SET_LOADING');
export const setLoadingMessage = createAction('SET_LOADING_MESSAGE');
